var MultiSelectAction = /* @__PURE__ */(MultiSelectAction2 => {
  MultiSelectAction2["ADD"] = "add";
  MultiSelectAction2["DELETE"] = "delete";
  return MultiSelectAction2;
})(MultiSelectAction || {});
export { MultiSelectAction };